import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { MarkdownContent } from './MarkdownContent';
import { updatesService } from '../services/updatesService';

interface UpdatesModalProps {
  version: string;
  content: string;
  onDismiss: () => void;
}

const UpdatesModal: React.FC<UpdatesModalProps> = ({ version, content, onDismiss }) => {
  const [submitting, setSubmitting] = useState(false);

  const handleDismiss = async () => {
    if (submitting) return;
    setSubmitting(true);
    try {
      await updatesService.markSeen(version);
      onDismiss();
    } catch {
      setSubmitting(false);
    }
  };

  return (
    <div className="modal modal-open">
      <div className="modal-box max-w-2xl max-h-[85vh] flex flex-col p-0 relative">
        <button
          type="button"
          className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2 z-10"
          onClick={handleDismiss}
          disabled={submitting}
          aria-label="Close"
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>

        <div className="p-4 border-b border-base-300">
          <h2 className="font-bold text-lg pr-8">Platform Updates</h2>
          <p className="text-sm text-base-content/80 mt-1">
            Here&apos;s what&apos;s new in the LTS Portal (v{version}).
          </p>
        </div>

        <div className="flex-1 overflow-y-auto p-4 min-h-[200px] max-h-[50vh] prose prose-sm max-w-none">
          {content ? (
            <MarkdownContent markdown={content} />
          ) : (
            <p className="text-base-content/70">No updates at this time.</p>
          )}
        </div>

        <div className="p-4 border-t border-base-300 flex justify-end">
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleDismiss}
            disabled={submitting}
          >
            {submitting ? (
              <>
                <span className="loading loading-spinner loading-sm" />
                ...
              </>
            ) : (
              'Got it'
            )}
          </button>
        </div>
      </div>
      <div
        className="modal-backdrop bg-black/50"
        onClick={handleDismiss}
        onKeyDown={(e) => e.key === 'Escape' && handleDismiss()}
        role="button"
        tabIndex={0}
        aria-label="Close"
      />
    </div>
  );
};

export default UpdatesModal;
